// @ts-strict-ignore
import moment from 'moment-timezone';
import React from 'react';
import {
  BankAccount,
  Icon,
  IconName,
  Text,
} from '@usealloy/component-library';

interface PortfolioEvaluationBankAccountsProps {
  accounts?: any[];
}

export const PortfolioEvaluationBankAccounts = ({
  accounts,
}: PortfolioEvaluationBankAccountsProps) => (
  accounts?.length ? (
    <>
      {accounts.map(data => (
        <BankAccount
          key={data.bank_account.bank_account_id}
          accountNumber={data.bank_account.account_number}
          balance={
            data.current_snapshot
              ? data.current_snapshot.account_balance
              : null
          }
          class={data.bank_account.account_class}
          currencyCode={data.bank_account.currency}
          dateActivated={
            data.bank_account.activation_date ? moment.utc(data.bank_account.activation_date).format('MMMM D, YYYY') : null
          }
          dateClosed={
            data.bank_account.closing_date ? moment.utc(data.bank_account.closing_date).format('MMMM D, YYYY') : null
          }
          dateOpened={
            data.bank_account.opening_date ? moment.utc(data.bank_account.opening_date).format('MMMM D, YYYY') : null
          }
          isExternalAccount={data.bank_account.is_linked_account}
          name={data.bank_account.account_name}
          status={
            data.current_snapshot?.status_description
              ? data.current_snapshot.status_description.toLowerCase()
              : 'open'
          }
        />
      ))}
    </>
  ) : (
    <>
      <Icon icon={IconName.Question} size="large" color="var(--cl-gray-600)" />
      <Text size={3} style={{ color: 'var(--cl-gray-600)' }}>No account overview information available</Text>
    </>
  )
);
